import { FC, useCallback } from 'react';

import Checkbox from '@mui/material/Checkbox';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

type Props = {
  selected: boolean;
  onChange: (selected: boolean) => void;
};

const SelectableListItem: FC<Props> = ({ selected, onChange, children }) => {
  const handleClick = useCallback(() => {
    onChange(!selected);
  }, [onChange, selected]);

  return (
    <ListItem disablePadding disableGutters onClick={handleClick}>
      <ListItemButton dense>
        <ListItemIcon>
          <Checkbox edge="start" disableRipple checked={selected} />
        </ListItemIcon>
        <ListItemText>{children}</ListItemText>
      </ListItemButton>
    </ListItem>
  );
};

export default SelectableListItem;
